import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const LibraryService = {
    listItems: async ({ folderId = null, orderBy = "name_asc", type = "all" }) => {
        const response = await axios.get(API_KEEPER + "/library/items", {
            params: {
                folderId: folderId,
                orderBy,
                type
            }
        });
        return response.data;
    },

    searchItems: async ({ search, orderBy = "name_asc", type = "all" }) => {
        const response = await axios.get(API_KEEPER + "/library/items/search", {
            params: {
                search,
                orderBy,
                type
            }
        });
        return response.data;
    },

    createFolder: async (payload) => {
        const response = await axios.post(API_KEEPER + "/library/folders", payload);
        return response.data;
    },

    updateItem: async ({ id, payload }) => {
        const response = await axios.put(API_KEEPER + `/library/items/${id}`, payload);
        return response.data;
    },

    deleteItem: async ({ id, confirmationText = null }) => {
        const response = await axios.delete(API_KEEPER + `/library/items/${id}`, {
            data: confirmationText ? { confirmationText } : null
        });
        return response.data;
    },

    deleteItems: async ({ ids, confirmationText = null }) => {
        const response = await axios.delete(API_KEEPER + "/library/items", {
            data: {
                ids,
                confirmationText
            }
        });
        return response.data;
    },

    uploadFile: async ({ parentId = null, file }) => {
        const formData = new FormData();

        if (parentId) {
            formData.append("parentId", parentId);
        }

        formData.append("file", file);

        const response = await axios.post(API_KEEPER + "/library/files", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });
    },

    getFolderOptions: async () => axios.get(API_KEEPER + "/library/folders/options").then(({ data }) => data).catch((err) => { throw err }),

    getDocById: async (id) => axios.get(API_KEEPER + `/library/documents/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    createDoc: async (formData) => axios.post(API_KEEPER + "/library/documents", formData).then(({ data }) => data).catch((err) => { throw err }),

    updateDoc: async (id, formData) => axios.put(API_KEEPER + `/library/documents/${id}`, formData).then(({ data }) => data).catch((err) => { throw err }),

    openPDF: (attachId) => API_KEEPER + `/ged/attach/print/pdf/${attachId}`,

    downloadFile: (attachId) => API_KEEPER + `/ged/attach/${attachId}`,

    downloadItem: (itemId) => API_KEEPER + `/library/download/items/${itemId}`,
}
export default LibraryService;